define.alias("shared/components/shared/ui/search-box/result-blank", "auth/components/shared/ui/search-box/result-blank");